import { render, staticRenderFns } from "./AddGoodTable.vue?vue&type=template&id=0e50af43&scoped=true&"
import script from "./AddGoodTable.vue?vue&type=script&lang=ts&"
export * from "./AddGoodTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e50af43",
  null
  
)

export default component.exports